const value = {
    goToLearning: 'Go to Learning',
    team: 'Team',
    noSuitableUnits: 'No units',
    textFiled: 'Text field',
    pickValue: 'Pick value',
    edithCategoryWithValuePick: 'Edit category with value',
    edithCategoryWithFieldText: 'Edit category with text field',
    activeCategory: 'Active',
    requiredCategory: 'Required',
    defaultValues: 'Default value',
    singleChoiceOnly: 'Single choice only',
    imageIsTooSmall: 'The image is too small. Minimum image size is 600 x 500 px.',
    passing: 'Unit passing',
    userRating: 'User rating',
    learninAnalytics: 'Learnin Analytics',
    editUnit: 'Edit unit',
    projectPage: 'Project',
    systems: 'Systems',
    failedToLoadUnitResults: 'Failed to load unit results',
    failedToFinishUnitResults: 'Failed to finish unit',
    systemPage: 'System profile',
    asRequirements: 'Requirements AS',
    addCategory: 'Create category',
    addValue: 'Create value',
    performerType: 'Requirements executor',
    activeDirectoryServers: 'Active Directory servers',
    editActiveDirectory: 'Edit Active Directory',
    addActiveDirectory: 'Create Active Directory',
    editUser: 'Edit user',
    addUser: 'Create user',
    usersManagement: 'User management',
    projectRoles: 'Project roles',
    systemRoles: 'System roles',
    addProjectRole: 'Create project role',
    editProjectRole: 'Edit project role',
    addTemplate: 'Create template',
    editTemplate: 'Edit template',
    addSystemRole: 'Create system role',
    editSystemRole: 'Edit system role',
    templates: 'Templates of profiles',
    logging: 'Logging',
    automatizationSystem: 'System',
    profileAS: 'System Profile',
    format: 'format',
    competencyMap: 'Expertise map',
    teamCompetencyMap: 'Team Expertise map',
    trainingNotSetYet: 'Training not set yet',
    noTrainingForThisSystem: 'There is no training for this system, check the required units in the knowledge tab',
    noMandatoryUnitsForTheRole: 'No mandatory units for the role',
    assignUnitsMessage: 'We recommend assigning mandatory units in the project roles settings.',
    setupProjectRoles: 'Setup project roles',
    profileCharacteristicsErrorMessage1:
      'The profile characteristics do not overlap with the characteristics of the required units',
    profileCharacteristicsErrorMessage2:
      'The profile does not contain characteristics from the mandatory units for project roles',
    fillOutTheProfile: 'Fill out the profile',
    rename: 'Rename',
    createCopy: 'Create copy',
    newFile: 'New file',
    fileName: 'File name',
    folderName: 'Folder name',
    emptyFileValidationError: 'No empty value allowed',
    newFolder: 'New folder',
    settings: 'Settings',
    project: 'Project',
    mandatory: 'Mandatory',
    optional: 'Optional',
    publish: 'Publish',
    published: 'Published',
    unpublish: 'Unpublish',
    edit: 'Edit',
    delete: 'Delete',
    junior: 'Junior',
    middle: 'Middle',
    champion: 'Champion',
    jiraFields: 'Jira fields',
    total: 'Total',
    never: 'Never',
    yesterday: 'Yesterday',
    ago: 'Ago',
    minuteAgo: 'Minute ago',
    now: 'Now',
    searchTable: 'Search table',
    toLearning: 'To learning',
    theory: 'Theory',
    quiz: 'Quiz',
    practice: 'Practice',
    min: 'Min',
    task: 'Task',
    question: 'Question',
    questions: 'Questions',
    selectType: 'Select type',
    comment: 'Comment',
    check: 'Check',
    retakeIn: 'Retake in',
    choosePracticeLang: 'Select a language for the practical tasks',
    chooseTheLang: 'Choose the language',
    langSelection: 'Language selection',
    fold: 'Fold',
    expand: 'Expand',
    of: 'Of',
    completeUnit: 'Complete unit',
    quit: 'Quit',
    results: 'Results',
    correctAnswer: 'Correct answer',
    wrongAnswer: 'Wrong answer',
    title: 'Title',
    subtitle: 'Subtitle',
    learning: 'Learning',
    users: 'Users',
    add: 'Create',
    cancel: 'Cancel',
    save: 'Save',
    confirmDeleteRecord: 'Delete the entry?',
    confirmDeleteRecordLabel: 'Are you sure you want to delete the entry?',
    yes: 'Yes',
    addRole: 'Add Role',
    units: 'Units',
    rights: 'Rights',
    description: 'Description',
    name: 'Name',
    nameTitle: 'Name',
    user: 'User',
    fromWhatDate: 'From what date',
    toWhatDate: 'To what date',
    events: 'Events',
    realizationStatus: 'Realization status',
    event: 'Event',
    idEvents: 'ID events',
    timeEvents: 'Time events',
    text: 'Text',
    dns: 'DNS',
    ip: 'IP',
    actions: 'Actions',
    admin: 'Admin',
    exclude: 'Exclude',
    include: 'Include',
    saveDraft: 'Save draft',
    preview: 'Preview',
    systemRole: 'System roles',
    notifications: 'Notifications',
    reading: 'Reading',
    creating: 'Creating',
    updating: 'Updating',
    deleting: 'Deleting',
    verification: 'Verification',
    sync: 'Synchronize',
    lastSynchronization: 'Last synchronization',
    integrations: 'Integrations',
    activeDirectory: 'Active Directory',
    login: 'Login',
    password: 'Password',
    confirmPassword: 'Password confirmation',
    userGroup: 'User group',
    projectUser: 'Project user',
    backToProject: 'Back to project',
    backToSettings: 'Back to settings',
    editProject: 'Edit project',
    addProject: 'Add project',
    addSystem: 'Add template',
    integratedWithTheSystem: 'Integrated with the System',
    youDoNotHavePermissionsToCreateSystems: 'You do not have permissions to create systems. Contact your administrator',
    fieldShouldContainNameOfProject: 'This field should contain the full name of the Project',
    fieldShouldContainUniqueIdentifierOfProject:
      'This field should contain a unique identifier of the project in the organization. In case of absence of the code, “Absent” shall be indicated',
    jiraLink: 'Jira link',
    jiraLinkDescription: 'Link to this product page in Jira',
    anyAdditionalProjectInformation: 'Any additional information about the project',
    nameOfUnit: 'Name of unit',
    specifications: 'Specifications',
    recommendedForRoles: 'Recommended for roles',
    unitCover: 'Unit cover',
    imageDiagram: 'Image diagram',
    system: 'System',
    single: 'Single',
    one: 'One',
    multi: 'Multi',
    langNotChosen: 'No lang choosen',
    doNotRandomize: 'Do not randomize',
    answers: 'Answers',
    addAnswer: 'Add an answer',
    linkFor: 'Link for',
    for: 'for',
    correct: 'Correct',
    minutes: 'Minutes',
    reward: 'Reward',
    award: 'Award',
    languages: 'Languages',
    type: 'Type',
    resetChanges: 'Reset all changes',
    notAdded: 'Not added',
    invitationLinks: 'Invitation links',
    deleteInvitationLinksHelper: 'This is a list of current links. If you delete it, it can no longer be added',
    newInvitationLink: 'New link',
    copiedToClipboard: 'Copied',
    isMarkedForDeleteHelper: 'Link removed',
    mustChangePasswordAfterLogin: 'Request a password change',
  };

export default value;
